module.exports = __webpack_public_path__ + "static/media/book-search.bb9bf9c0.png";